"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = calculateTotalPay;
exports.calculateTotalStipend = calculateTotalStipend;
const number_utils_1 = require("./number-utils");
/**
 * Calculates total nurse pay without needing to subtract out fees.
 *
 * @param payRate The pay rate for the shift/orientation.
 * @param minutesWorked Minutes worked for given shift.
 * @param stipend Sum of all stipend fees paid to nurse.
 * @return Total nurse pay.
 */
function calculateTotalPay(payRate, minutesWorked, stipend) {
    return Math.round(payRate * (0, number_utils_1.roundToAtMostTwoDecimals)(minutesWorked / 60) + stipend);
}
function calculateTotalStipend(stipends) {
    return stipends
        ? stipends.reduce((total, stipend) => stipend.amount + total, 0)
        : 0;
}
//# sourceMappingURL=pay-calculator.js.map